import { openBlobFile } from "@/utils/utils";
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { productCommissionsSettingsApi } from "../../../../modules/commissions/productcommissionssettings/api";
import {
  BusinessCoefficientsReportFilterExportRequest,
  BusinessCoefficientsReportFilterPageRequest,
  CreateUpdateProductCommissionsSettings,
} from "../../../../modules/commissions/productcommissionssettings/types";
import { CreateUpdateEntries, EntityIdObject, EntityObject } from "../../../types";
import { PRODUCT_COMMISSIONS_SETTINGS_QUERY_KEYS } from "./queryKeys";

export const useUpdateProductCommissionsSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: PRODUCT_COMMISSIONS_SETTINGS_QUERY_KEYS.createUpdateProductCommissionsSettings(),
    mutationFn: async (payload: EntityObject<CreateUpdateEntries<CreateUpdateProductCommissionsSettings>>) => {
      const { data } = await productCommissionsSettingsApi.createUpdateProductCommissionsSettings(payload);

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PRODUCT_COMMISSIONS_SETTINGS_QUERY_KEYS.filterBusinessCoefficientsReport(),
      });
    },
  });
};

export const useGetProductBusinessCoefficients = () => {
  return useMutation({
    mutationKey: PRODUCT_COMMISSIONS_SETTINGS_QUERY_KEYS.getProductBusinessCoefficients(),
    mutationFn: async (payload: EntityIdObject) => {
      const { data } = await productCommissionsSettingsApi.getProductBusinessCoefficients(payload);

      return data;
    },
  });
};

export const useFilterBusinessCoefficientsReport = (payload: BusinessCoefficientsReportFilterPageRequest) => {
  return useQuery({
    queryKey: PRODUCT_COMMISSIONS_SETTINGS_QUERY_KEYS.filterBusinessCoefficientsReport(payload),
    queryFn: async () => {
      const { data } = await productCommissionsSettingsApi.filterBusinessCoefficientsReport(payload);

      return data;
    },
    placeholderData: keepPreviousData,
  });
};

export const useDownloadBusinessCoefficientsExport = () => {
  return useMutation({
    mutationKey: PRODUCT_COMMISSIONS_SETTINGS_QUERY_KEYS.downloadBusinessCoefficientsExport(),
    mutationFn: async (payload: BusinessCoefficientsReportFilterExportRequest) => {
      const response = await productCommissionsSettingsApi.downloadBusinessCoefficientsExport(payload);
      openBlobFile(response, true);

      return response.data;
    },
  });
};
